<template>
  <div class="content column">
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index1_title2_img.png'"
        alt="少儿编程"
        style="width: 461px;height: 82px;margin-top: 224px;"
      ></el-image>
    </div>
    <div class="center text">
      体系完整，循序渐进，逐步提升
    </div>
    <!-- 线上课程体系 -->
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/线上课程体系.png'"
        alt="少儿编程"
        style="width: 1220px;height: 945px;margin-top: 60px;"
      ></el-image>
    </div>
    <div class="center note">*线上课程体系</div>
    <!-- 线下课程体系 -->
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/线下课程体系.png'"
        alt="少儿编程"
        style="width: 1220px;height: 718px;margin-top: 20px;"
      ></el-image>
    </div>
    <div class="center note">*线下课程体系</div>
    <!-- 免费领取 -->
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index_box2_btn.png'"
        alt="少儿编程"
        style="width: 410px;height: 160px;margin-top: 90px; cursor: pointer;"
        @click="scrollToBottom"
      ></el-image>
    </div>

    <!-- 特色教学方法 -->
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index1_title3_img.png'"
        alt="少儿编程"
        style="width: 376px;height: 82px;margin-top: 100px;"
      ></el-image>
    </div>
    <div class="center text">
      以学生为主体，启发学生思考与创新
    </div>
    <div class="center">
      <div class="between" style="width: 1200px;margin-top: 80px;">
        <div class="left column-between">
          <div
            class="item"
            v-for="(i, index) in 5"
            :key="index"
            @click="updateActive(index)"
          >
            <div class="row" style="height: 65px;">
              <div class="center-just left-image-div ">
                <el-image
                  :src="
                    $domain +
                      'static/noten/website/newHome/index_box3_icon' +
                      (index + 1) +
                      '.png'
                  "
                  class="left-image"
                ></el-image>
              </div>
              <div style="align-self: center;" class="left-text">
                {{ typeList[index] }}
              </div>
            </div>
            <div v-if="index == active" class="recommend">
              {{ contentList[index] }}
            </div>
          </div>
        </div>

        <div class="right">
          <el-image
            :src="$domain + 'static/noten/website/newHome/index_box3_ipad1.png'"
            alt="少儿编程"
            style="width: 758px;height: 489px;"
          ></el-image>
        </div>
      </div>
    </div>

    <!-- 教学闭环 -->
    <div class="center">
      <el-image
        :src="$domain + 'static/noten/website/newHome/index1_title4_img.png'"
        alt="少儿编程"
        style="width: 462px;height: 82px;margin-top: 166px;"
      ></el-image>
    </div>
    <div class="center text">
      专业师资，精品课程，教学练测评一体
    </div>
    <div class="center">
      <div class="between" style="width: 1200px;margin-top: 70px;">
        <el-image
          :src="$domain + 'static/noten/website/newHome/次元口袋课程闭环.png'"
          alt="少儿编程"
          style="width: 539px;height: 537px;"
        ></el-image>

        <el-image
          :src="$domain + 'static/noten/website/newHome/及时巩固学以致用.png'"
          alt="少儿编程"
          style="width: 599px;height: 601px;"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      sidebarActive: 4,
      typeList: [
        "故事式教学方法",
        "互动式教学方法",
        "游戏式教学方法",
        "项目式教学方法",
        "竞赛式教学方法"
      ],
      contentList: [
        "设置恐龙世界，智能城市，地底探险主题的一系列探险故事，让学生在探险的同时，理解编程逻辑思维。",
        "线上真人直播教学，与学生实时互动，激发学生的学习兴趣和主动性。",
        "将消消乐、打地鼠、乒乓球对战等学生熟悉的游戏做成课程，引导学生理解游戏设置的逻辑，让学生自己动手做游戏。",
        "设立项目主题课程，比如保卫家园，让学生在前期课程储备的基础上自主分析项目逻辑，设计方案，独立完成项目，老师适时进行指导和提醒。",
        "组织学生参加线上和线下的编程竞赛，让学生展现和提高自己的编程水平，激发学习兴趣和竞争意识。"
      ]
    };
  },
  methods: {
    switchType(index) {
      this.active = index;
      this.toTop();
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    sidebar(index) {
      this.sidebarActive = index;
    },
    out() {
      this.sidebarActive = 4;
    },
    updateActive(active) {
      this.active = active;
    },
    scrollToBottom() {
      this.$emit("custom-event");
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  background-image: url("http://static.smallschoolbag.com/static/noten/website/newHome/index_bg.png");
  background-size: 100% 100%;
  height: 4302px;
  .text {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #808080;
    margin-top: 20px;
  }
  .note {
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1a1a1a;
    margin-top: 20px;
  }
  .left {
    width: 400px;
    height: 490px;
    .recommend {
      width: 312px;
      line-height: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 300;
      color: #4d4d4d;
      display: flex;
      margin-left: auto;
      padding-bottom: 15px;
      padding-right: 20px;
    }
    .item {
      width: 400px;
      min-height: 70px;
      background: #f7f7f7;
      border-radius: 10px;
      .left-image-div {
        width: 70px;
        .left-image {
          height: 38px;
          width: 38px;
          align-self: center;
        }
      }

      .left-text {
        align-self: center;
        flex: 1;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #1a1a1a;
      }
    }
  }
  .right {
    // background-color: #808080;
    width: 758px;
    height: 490px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/boxList/box2.vue